module.exports = __webpack_public_path__ + "static/media/Profile_inactive1.364438d5.svg";